import React, { useEffect, useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import "./App.css";
import AppRoutes from "./routes/routes";
import "../src/utils/i18n/i18n";
import { useTranslation } from "react-i18next";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

import brasil_flag from "./assets/images/brasil.png";
import eua_flag from "./assets/images/estados-unidos.png";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    (document.body.style as any).zoom = "90%";
    (document.body.style as any).paddingTop = '10vh';
  }, []);
  
  const changeLanguage = () => {
    
    if (i18n.language == 'pt') {
      localStorage.setItem("language", "en");
      i18n.changeLanguage("en");
      return;
    }

    localStorage.setItem("language", "pt");
    i18n.changeLanguage("pt");
  };


  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CartProvider>
          <ChakraProvider>
            <div className="fixed cursor-pointer z-[99] w-20 !border-1 !border-[#45B7FE]  rounded-l-lg bg-[#50700f] top-1/6 -right-7 hover:duration-200 hover:-translate-x-[10px]" onClick={() => changeLanguage()}>
              <img className="w-10 ml-1" src={i18n.language == "pt" ? brasil_flag : eua_flag} alt="" />
            </div>
            <AppRoutes />
          </ChakraProvider>
        </CartProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
